<template>
  <div class="member-swipe">
    <swiper :options="swiperOption" class="member-swipe-main" :style="swiperHeight">
      <swiper-slide v-for="(item, index) in bgImgs" :key="index">
        <div class="swipe-item mk-flex-row-start-center">
          <div
            class="swiper-slide-img-header mk-flex-column-start-center">
            <div class="header-url">
              <img class="header-url-img" :src="item.url">
            </div>
            <div class="header-desc mk-flex-column-center-center">
              <p>
                <span class="desc-name">{{item.name}}</span>
                <span>{{item.title}}</span>
              </p>
              <p class="occupation">{{item.occupation}}</p>
            </div>
          </div>
          <div class="item-text">
            <p v-html="item.descHtml"></p>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'member-info',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    currentName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      bgImgs: [
        {
          name: '刘燕飞',
          info: require('@/assets/img/member-item.png'),
          url: require('@/assets/img/liuyanfei.png'),
          title: '（主席）',
          occupation: '护士学硕士、副主任护师',
          descHtml: '医学硕士、副主任护师<br>1995年 医学学士 复旦大学医学院（原上海医科大学）<br>2008年 医学硕士 复旦大学<br>复旦大学附属肿瘤医院临床试验机构办公室<br>参与国际国内I-III期注册临床试验项目管理50余项。负责临床研究机构的运行管理，临床研究人员的相关培训与管理、具有多年的研究护士和CRC的培训及管理经验、临床研究合同的管理、中心化临床研究药物的管理、临床研究信息化建设及管理等。<br>国家食品药品监督管理总局（CFDA）临床试验数据现场核查检查员<br>中国抗癌协会临床试验稽查协作组 副主任委员<br>DIA上海CRC之家 理事长<br>参与科技部重大新药创制平台十一五、十二五课题<br>参编临床研究护士相关专著：<br>2013   参编 美国ONS《manual for clinical trial nursing》 V3<br>2016   主编《CRC工作指南》复旦大学出版社 <br>2017   主译《manual for clinical trial nursing》V3 <br>'
        },
        {
          name: '刘晓红',
          info: require('@/assets/img/member-item.png'),
          url: require('@/assets/img/liuxiaohong.png'),
          title: '（副主席）',
          occupation: '护理学硕士，副主任护师',
          descHtml: '2006年硕士毕业于中国协和医科大学护理学院，成为北京肿瘤医院第一名研究护士<br>2012年被聘为国家药物临床试验机构研究护士及I期临床病区护士长<br>参加国际、国内多中心临床试验管理100余项。中华护理学会北京分会会员、国际研究护士协会（IACRN）会员。《中华现代护理杂志》特约审稿人<br>2016年12月成为CFDI国家检查员<br>中国抗癌协会肿瘤临床试验稽查协作组（CTAG）副秘书长。 <br>'
        }
        ,
        {
          name: '葛洁英',
          info: require('@/assets/img/member-item.png'),
          url: require('@/assets/img/gejieying.jpg'),
          title: '（副主席）',
          occupation: 'CRC/CRN专业组组长',
          descHtml: '中山大学肿瘤防治中心 临床研究部 研究护士护长<br>广东省药学会药物临床试验专业委员会CRC/CRN专业组组长<br>毕业于武汉大学护理学院，现主要负责医院I-III期的抗肿瘤新药临床试验的项目实施与协调，同时负责医院研究护士队伍建设与管理，院外CRC管理<br>曾于2013年赴美国约翰斯霍普金斯大学医院学习临床研究项目实施管理，参与设计中山大学与Johns Hopkins的CRC联合培训课程。<br>'
        },
        {
          name: '赵青',
          info: require('@/assets/img/member-item.png'),
          url: require('@/assets/img/zhaoqing.png'),
          title: '（副主席）',
          occupation: '食品药品监督管理局GCP检查员',
          descHtml: '毕业于南京医科大学，从事临床试验管理工作十余年，有丰富的合同管理、质控、培训经验，参与并管理临床试验百余项<br>现担任江苏省食品药品监督管理局GCP检查员<br>南京市药学会临床试验专业委员会委员<br>中国肿瘤临床试验稽查组委员<br>参与国际国内I-III期注册临床试验项目管理50余项。负责临床研江苏省医院协会医院科技教育管理专业委员会GCP专业学组成员 <br>'
        }
      ],
      swiperHeight: 'height: 385px;',
      // swiper配置数据
      swiperOption: {
        autoplay: {
          delay: 3000, //自动切换的时间间隔，单位ms
          stopOnLastSlide: true, //如果设置为true，当切换到最后一个slide时停止自动切换。
          disableOnInteraction: true, //用户操作swiper之后，是否禁止autoplay。
          reverseDirection: true, //开启反向自动轮播。
          waitForTransition: true, //等待过渡完毕。自动切换会在slide过渡完毕后才开始计时。
        },
        navigation: {
          nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
          hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
        }
      }
    }
  },
  watch: {
    // currentName (val) {
    //   if (!val) return
    //   this. this.bgImgs.findIndex(item => item.name === 'val')
    // }
  }
}
</script>
<style lang="css" src="./../assets/css/swiper.css"></style>
<style scoped>
  .member-swipe {
    width: 990px;
    height: 385px;
    position: relative;
  }
  .member-swipe-main {
    width: 920px;
    height: 100%;
  }
  .swipe-item {
    width: 100%;
    height: 100%;
  }
  .swiper-slide-img {
    width: 100%;
    height: 100%;
  }
  .swiper-button-next {
    right: -10px;
    background-image: url("./../assets/img/icn-arrow-blue-right.png");
  }
  .swiper-button-prev {
    left: -10px;
    background-image: url("./../assets/img/icn-arrow-blue-left.png");
    transform: rotate(0deg);
  }
  .swiper-slide-img-header {
    width: 200px;
    height: 325px;
  }
  .swiper-slide-img-header:first-child {
    margin-left: 0px;
  }
  .header-url {
    width: 200px;
    height: 260px;
    overflow-y: scroll;
  }
  .header-url-img {
    width: 100%;
    min-height: 260px;
  }
  .header-desc {
    width: 100%;
    height: 65px;
    color: #ffffff;
    background-color: #2859D1;
    font-size: 12px;
  }
  .desc-name {
    font-size: 22px;
    font-weight: 800;
  }
  .occupation {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  .item-text {
    margin-left: 15px;
    flex: 1;
    height: 325px;
  }
  .item-text p {
    text-align: left;
  }
</style>
